import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronDownIcon, CalendarIcon } from './icons';

const linkStyle = {
  fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#0f0f0f', textDecoration: 'none',
};

export function Navbar() {
  return (
    <header
      style={{
        position: 'sticky', top: 0, zIndex: 100, background: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(8px)'
      }}
    >
      <div
        style={{
          maxWidth: 1400, margin: '0 auto', padding: '0px 24px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24, height: 80
        }}
      >
        <Link to="/v2" style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <img src="/landing/logo.png" alt="Sleengshort" width={140} height={36} style={{ objectFit: 'contain', width: 'auto', height: 36 }} loading="eager" />
        </Link>

        <nav style={{ display: 'flex', alignItems: 'center', gap: 32, flex: 1, justifyContent: 'center' }} className="landing-nav-links">
          <span style={{ ...linkStyle, display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer' }}>
            Solutions <ChevronDownIcon />
          </span>
          <a href="#solutions" style={linkStyle}>Pricing</a>
          <a href="#" style={linkStyle}>About Us</a>
          <a href="#" style={linkStyle}>Developers</a>
          <span style={{ ...linkStyle, display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer' }}>
            Resources <ChevronDownIcon />
          </span>
        </nav>

        <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexShrink: 0 }}>
          <a href="/login" style={linkStyle} className="landing-nav-links">Login</a>
          <a href="/login" style={{ textDecoration: 'none' }}>
            <motion.span
              whileHover={{ opacity: 0.9 }}
              whileTap={{ scale: 0.97 }}
              style={{
                height: 38, padding: '0 18px', background: '#014ed2', borderRadius: 7,
                display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontFamily: 'Inter, sans-serif',
                fontWeight: 600, color: '#fff', whiteSpace: 'nowrap',
              }}
            >
              <CalendarIcon />
              Book a Demo
            </motion.span>
          </a>
        </div>
      </div>
    </header>
  );
}
